export abstract class IGraphqlMapper {
  abstract returnFromJson(json: any): any;
}
